// AUTOPIA – Stacked Parallax Service Cards
document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll("[data-autopia-card]");

  // Assign z-index so later cards sit above earlier ones
  cards.forEach((card, i) => {
    card.style.zIndex = i + 1;
  });

  // IntersectionObserver to toggle visible class
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        entry.target.classList.toggle(
          "autopia-card--visible",
          entry.isIntersecting
        );
      });
    },
    {
      root: null,
      threshold: 0.35, // slightly earlier trigger feels smoother
      rootMargin: "0px 0px -10% 0px" // improves mobile reveal timing
    }
  );

  cards.forEach(card => observer.observe(card));
});
